import axios from "axios";

export const useUpdate = async (url, payload = {}) => {
  const header = {
    headers: { session: localStorage.getItem("session_id") },
  };
  const dataRes = await axios.put(url, payload, header);
  return dataRes;
};
